import { SumMoney } from 'model/Money'
import {
  MoneyDto,
  QuotationBoMItemActivityLineDto,
  QuotationLineDto,
} from 'services/APIs/InternalAPI/internal-api.contracts'

const toMoneyDto = (money: MoneyDto | null | undefined): MoneyDto | null => {
  if (!money) return null
  if ('amount' in money) {
    return {
      value: money.amount as number,
      currency: money.currency,
      symbol: money.symbol,
    }
  }
  return 'value' in money ? money : null
}

const sumMoneyValues = (
  values: Array<MoneyDto | null | undefined>,
): MoneyDto | null => {
  const normalized = values
    .map(toMoneyDto)
    .filter((money): money is MoneyDto => money?.value !== undefined)
  return normalized.length > 0 ? SumMoney(normalized) : null
}

export function calculateSelectedLinePrice(
  line: QuotationLineDto | undefined,
  isSelected: (
    activity: QuotationBoMItemActivityLineDto,
    index: number,
  ) => boolean,
): MoneyDto | null {
  const activities = (line?.quotationBomItemLines ?? []).flatMap(
    (bomItemLine) => bomItemLine.activities ?? [],
  )
  const selectedActivities = sumMoneyValues(
    activities.map((activity, index) =>
      isSelected(activity, index) ? activity.salesPrice : null,
    ),
  )
  const persistedActivities = sumMoneyValues(
    activities.map((activity) =>
      activity.includeInQuotation !== false ? activity.salesPrice : null,
    ),
  )
  const linePrice = toMoneyDto(line?.salesPrice)

  if (!linePrice) return selectedActivities

  return {
    ...linePrice,
    value:
      Math.max(0, linePrice.value - (persistedActivities?.value ?? 0)) +
      (selectedActivities?.value ?? 0),
  }
}
